/**
 * Helper to fetch fake feed data from PUBLIC_URL on prod builds.
 * Uses local fakes during development.
 * @param {string} url Should start with `/`
 */
function dataUrl(url) {
  return process.env.NODE_ENV === "production"
    ? process.env.PUBLIC_URL + url
    : url;
}

/**
 * Get the fake data at `jsonPath`. The JSON includes the race data in the
 * `races` field.
 *
 * @param {string} jsonPath
 * @returns {Object} JSON from file
 */
export async function fetchFake(jsonPath) {
  console.debug(`Using fake feed data: ${jsonPath}`);
  const response = await fetch(dataUrl(jsonPath));
  return response.json();
}
